import React from 'react';
import { Car, Smartphone, Cpu } from 'lucide-react';
import { industries } from '../data/mock';

const iconMap = {
  'Automotive': Car,
  'Mobile': Smartphone,
  'AI & Technology': Cpu
};

const Industries = () => {
  return (
    <section className="section-padding" id="industries">
      <div className="container">
        <div className="section-header">
          <p className="section-label">Industries</p>
          <h2 className="section-title">Domains We Serve</h2>
          <p className="section-description">
            Deep expertise across automotive, mobile, and AI domains—not generic IT consulting.
          </p>
        </div>
        
        <div className="industries-grid">
          {industries.map((industry) => {
            const IconComponent = iconMap[industry.name] || Car;
            return (
              <div key={industry.name} className="industry-card">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-[var(--accent-subtle)] rounded-xl flex items-center justify-center text-[var(--accent-primary)]">
                    <IconComponent size={24} />
                  </div>
                </div>
                <h3 className="industry-name">{industry.name}</h3>
                <p className="industry-description">{industry.description}</p>
                <div className="industry-focus">
                  {industry.focus.map((item) => (
                    <span key={item} className="focus-tag">{item}</span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
